// extracted by mini-css-extract-plugin
export var actions = "_2b-0";
export var actionsContainer = "_2b-7";
export var border = "_2b-1";
export var childFullHeight = "_2b-f";
export var collapse = "_2b-2";
export var content = "_2b-a";
export var contentChild = "_2b-e";
export var fullscreen = "_2b-c";
export var hasLeftRadius = "_2b-k";
export var headerContainer = "_2b-3";
export var headerRow = "_2b-5";
export var hidePadding = "_2b-b";
export var navCollapsedGap = "_2b-l";
export var noScrollX = "_2b-m";
export var noScrollY = "_2b-n";
export var noTopPadding = "_2b-i";
export var optOutTopPadding = "_2b-d";
export var pageMain = "_2b-j";
export var pageOuter = "_2b-g";
export var pagePadding = "_2b-8";
export var pageScroll = "_2b-9";
export var profile = "_2b-o";
export var profileContainer = "_2b-p";
export var profileImage = "_2b-q";
export var profileMain = "_2b-r";
export var profileSubtitle = "_2b-t";
export var profileTitle = "_2b-s";
export var showLeftPadding = "_2b-h";
export var tabsPortalSlot = "_2b-6";
export var tabsWrapper = "_2b-4";
export var title = "_2b-u";